import { inject, Injectable, signal } from '@angular/core';
import { BrandsEnum } from '../../models/enums/brands.enum';
import { WindowService } from '../window/window.service';
import { getBrandFromHostname } from '../../utils/brand-hostname.util';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  private windowService = inject(WindowService);

  brandSig = signal<BrandsEnum | null>(null);

  setBrandByHostname(host?: string) {
    this.brandSig.set(this.getBrandFromHostname(host));
  }

  ensureBrandEnumValue(value: string): BrandsEnum | null {
    if (Object.values(BrandsEnum).includes(value as BrandsEnum)) {
      let brandValue: BrandsEnum = value as BrandsEnum;
      if (brandValue === BrandsEnum.KEARNS) {
        brandValue = BrandsEnum.KEARNS_BROTHERS;
      }
      return brandValue;
    } else {
      return null;
    }
  }

  getBrandFromHostname(host?: string): BrandsEnum {
    return getBrandFromHostname(
      host ?? this.windowService.getHostname() ?? undefined,
    );
  }
}
